import * as React from 'react';
import { Button } from './button';

import styles from './add-button.scss';

export interface AddButtonProps {
  icon: React.ComponentClass<any> | React.FC<any>;
  onClick: (event: any) => void;
  required?: boolean;
  children?: React.ReactNode;
  disabled?: boolean;
}

export const AddButton = (props:AddButtonProps) => {
  const Icon = props.icon;
  const required = props.required;

  return (
    <div className="add-button">
      {required && <span className="asterisk-required">* </span>}
      <Button
      btnType={styles.addButton}
      onClick={props.onClick}
      disabled={props.disabled}>
        {props.icon && <span className={`${styles.iconStyle}`}><Icon /></span>}
        <span className={`${styles.addButtonText}`}>{props.children}</span>
      </Button>
    </div>
  );
};
